import graphqlClient from '~/graphql/graphqlClient';
import {
  MutationSteamPurchasePopupClosedArgs,
  SteamPurchaseResult,
} from 'dt-common/generated/graphql-types';

const mutation = `
mutation SteamPurchasePopupClosed($playerId: String!, $orderid: String!, $transid: String, $pdAmount: Int!, $platform: String!) {
  steamPurchasePopupClosed(playerId: $playerId, orderid: $orderid, transid: $transid, pdAmount: $pdAmount, platform: $platform) {
    completed
    currency1
    pdAmount
  }
}
`;

export default async function mutationSteamPurchasePopupClosed(
  args: MutationSteamPurchasePopupClosedArgs
) {
  return await graphqlClient.request<SteamPurchaseResult>(
    'steamPurchasePopupClosed',
    mutation,
    args
  );
}
